var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.40332,
    y: 15.1826,
    width: 11.0018,
    height: 2,
    rx: 1,
    transform: "rotate(-45 7.40332 15.1826)",
    fill: "#272932"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.81689,
    y: 7.40234,
    width: 11.0033,
    height: 2,
    rx: 1,
    transform: "rotate(45 8.81689 7.40234)",
    fill: "#272932"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/close_gray.490ed58e9dee7f8fba5429d9cd7811b8.svg";
export { ForwardRef as ReactComponent };